import { getActingPartnerCurrency } from "./actingPartner";
import { getSearchCurrency } from "./searchCurrency";

export function getFormattedCurrency(price: number) {
  if (price === 0) return "";
  return Number(price).toLocaleString("en-US");
}

export function getHotelCurrency(hotelDetails: any): string | undefined {
  return (
    hotelDetails?.totalPrice?.currency ||
    hotelDetails?.pricePerRoom?.currency ||
    hotelDetails?.currency ||
    undefined
  );
}

function resolveCurrencyCode(currencyCode?: string | null): string {
  return (
    (currencyCode || "").trim().toUpperCase() ||
    (getSearchCurrency() || "") ||
    (getActingPartnerCurrency() || "").trim().toUpperCase() ||
    "USD"
  );
}

export function formatCurrency(amount: number, currencyCode?: string | null): string {
  const code = resolveCurrencyCode(currencyCode);
  const value = Number.isFinite(amount) ? amount : 0;
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${code} ${Math.round(value).toLocaleString("en-US")}`;
  }
}

export function currencySymbol(currencyCode?: string | null): string {
  const code = resolveCurrencyCode(currencyCode);
  try {
    const symbol = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
      .formatToParts(0)
      .find((part) => part.type === "currency")?.value;
    if (!symbol) return `${code} `;
    return /^[A-Za-z]{2,}$/.test(symbol) ? `${symbol} ` : symbol;
  } catch {
    return `${code} `;
  }
}

const MONEY_FORMAT = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatMoney(value: unknown, symbol: string = currencySymbol()): string {
  const amount = Number(value);
  return `${symbol}${MONEY_FORMAT.format(Number.isFinite(amount) ? amount : 0)}`;
}
